import { render, staticRenderFns } from "./DesktopMenuBar.vue?vue&type=template&id=7333b67a&"
import script from "./DesktopMenuBar.vue?vue&type=script&lang=js&"
export * from "./DesktopMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMenuBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports